<span class="slider-block date-range-slider-block">
	<span
		*ngIf="!showWeeks && todayPositionPercent !== null"
		class="date-range-today-indicator"
		[style.left.%]="todayPositionPercent"
		aria-hidden="true">Today</span>
	<input
		type="range"
		[min]="minDateTimestamp"
		[max]="maxDateTimestamp"
		[value]="selectedDateTimestamp"
		[disabled]="dateLabels.length === 0"
		[attr.list]="rangeLabelsId"
		(input)="onDateChanged($event)"
		class="date-range-slider"
	/>
	<span
		*ngIf="!showWeeks && todayPositionPercent !== null"
		class="date-range-today-tick"
		[style.left.%]="todayPositionPercent"
		aria-hidden="true"></span>
	<datalist [id]="rangeLabelsId" class="date-range-slider-labels">
		<option *ngFor="let date of dateLabels" [value]="date.getTime()" [label]="formatDate(date)"></option>
	</datalist>
</span>
